export default "__VITE_ASSET__6406dcd4__"